// extracted by mini-css-extract-plugin
export var parcelRow = "_su-0";